import { PaginatedResponse } from 'ui/types/interfaces';
import { MeasurementUnit } from 'ui/types/measurementUnit';

import { useQuery } from '~/hooks/useQuery';

export const useLoadMeasurementUnits = () => {
  return useQuery<PaginatedResponse<MeasurementUnit[]>>(
    'measurement-units/default-units',
  );
};

export const useLoadMeasurementUnit = (id = '') => {
  return useQuery<MeasurementUnit>(`measurement-units/${id}`, {
    queryOptions: {
      enabled: !!id,
    },
  });
};
